<form class="generic-form" [formGroup]="genericFormGroup" (ngSubmit)="onSubmit()" novalidate>
  @for (field of fields; track field.key) {
    <div class="generic-form__field">
      @switch (field.type) {
        @case ('select') {
          <bodyanalytics-field-select
            [formControlName]="field.key"
            [inputId]="fieldId(field)"
            [label]="field.label"
            [options]="selectOptions(field)"
            [error]="errorMessage(field)"
            [matTooltip]="field.tooltip || ''"
            [matTooltipPosition]="$any(field.tooltipPosition || 'below')" />
        }
        @case ('textarea') {
          <bodyanalytics-field-label [for]="fieldId(field)" [text]="field.label" />
          <textarea
            class="generic-form__textarea"
            [class.generic-form__textarea--invalid]="!!errorMessage(field)"
            [id]="fieldId(field)"
            [formControlName]="field.key"
            [placeholder]="field.placeholder || ''"
            [attr.aria-invalid]="errorMessage(field) ? 'true' : null"
            [attr.aria-describedby]="errorMessage(field) ? fieldId(field) + '-error' : null"
            rows="3"></textarea>
          @if (errorMessage(field); as message) {
            <p class="generic-form__error" role="alert" [id]="fieldId(field) + '-error'">
              <i class="bx bx-error-circle" aria-hidden="true"></i>
              {{ message }}
            </p>
          }
        }
        @case ('checkbox') {
          <bodyanalytics-field-toggle
            [formControlName]="field.key"
            [inputId]="fieldId(field)"
            [label]="field.label"
            [matTooltip]="field.tooltip || ''"
            [matTooltipPosition]="$any(field.tooltipPosition || 'below')" />
        }
        @default {
          <bodyanalytics-field-input
            [formControlName]="field.key"
            [inputId]="fieldId(field)"
            [label]="field.label"
            [type]="inputType(field)"
            [placeholder]="field.placeholder || ''"
            [error]="errorMessage(field)"
            [matTooltip]="field.tooltip || ''"
            [matTooltipPosition]="$any(field.tooltipPosition || 'below')" />
        }
      }
    </div>
  }
  <button bodyanalyticsFormSubmit type="submit">{{ submitLabel() ?? 'Submit' }}</button>
</form>
